import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';
import { createOfflineFilterOptionsRepository } from './filterOptions/createOfflineFilterOptionsRepository';

const commonRepository = createOfflineCommonRepository(() => offlineDatabase.sizes);

const filterOptionsRepository = createOfflineFilterOptionsRepository(
  () => offlineDatabase.sizes,
  ['name'],
);

export const offlineSizesRepository = {
  ...commonRepository,
  ...filterOptionsRepository,
};
